import baseObject from '#frontend/dtm/shared/base.js';

/**
 * Error page object
 * @param {object} cart Cart object
 * @param {string|null} errorType Specified error type
 * @returns {object} Created Cart Page object
 */
export default (cart, errorType) => {
	const errorName = errorType || cart.error?.app.status || 0;
	return {
		page_name: `error-${errorName}`,
		...baseObject(cart)
	};
};
